<template>
    <InputNullableFloat
        ref="inputref"
        v-model="value"
        :placeholder="placeholder"
        :validator="props.validator"
        :readonly="props.readonly"
        :disabled="props.disabled"
        :icon="props.icon"
        :icon-family="props.iconFamily"
        :id="props.id"
        :label="props.label"
        :label-position="props.labelPosition"
        :maxlength="props.maxlength"
        :select-on-focus="props.selectOnFocus"
        :mark-text-part="props.markTextPart"
        :modelModifiers="modelModifiers"
        :posttext="props.posttext"
        :tooltip="props.tooltip"
    />
</template>
<script setup lang="ts">
import { type IInputFloatModelValueType, InputNullableFloat, type IInputFloatPropsWithoutModelValue } from '@/components';
import type { IEditorComponent } from '@/objects/gui';
import { computed, ref, type ComponentPublicInstance } from 'vue';

const props = withDefaults(defineProps<IInputFloatPropsWithoutModelValue>(), {
    validator: null,
});

const modelValue = defineModel<IInputFloatModelValueType>({ required: true });

const value = computed<number>({
    get: () => modelValue.value,
    set: (value) => {
        if (value !== null) {
            modelValue.value = value;
        }
    },
});

const inputref = ref<ComponentPublicInstance<IEditorComponent> | null>(null);

defineExpose({
    focus: () => inputref.value?.focus(),
    KeyboardEvent: (ev: KeyboardEvent) => {
        const input = ev.key;
        if (!isNaN(Number(input))) {
            value.value = Number(input);
            return;
        }
        throw new Error(`Cannot parse input '${input}' to float`);
    },
});
</script>
